import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { Download } from 'react-bootstrap-icons';

export default function FloatingButton({ obtenerImagenesVisibles, nomCategoria }) {
    const [showSnackbar, setShowSnackbar] = useState(true); // Mostrar la alerta automáticamente al renderizar

    const descargarImagenes = async (imageUrls) => {
        if (!imageUrls || imageUrls.length === 0) {
            alert("No hay imágenes para descargar.");
            return;
        }

        imageUrls.forEach(async (url, index) => {
            try {
                // Agrega un parámetro único (timestamp) a la URL para evitar la caché
                const uniqueUrl = `${url}?timestamp=${Date.now()}`;
                const response = await fetch(uniqueUrl);  // Usa la URL con el parámetro único

                if (!response.ok) {
                    throw new Error(`Error HTTP: ${response.status}`);
                }

                const blob = await response.blob();
                const blobUrl = window.URL.createObjectURL(blob);

                const link = document.createElement("a");
                link.href = blobUrl;
                link.setAttribute("download", `${nomCategoria}_img_${index + 1}.jpg`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // Liberar memoria
                setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
            } catch (error) {
                console.error(`Error al descargar imagen ${index + 1}:`, error);
            }
        });
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowSnackbar(false); // Oculta la alerta automáticamente después de 3 segundos
        }, 3000);
        return () => clearTimeout(timer); // Limpia el temporizador al desmontar el componente
    }, []);

    return (
        <div className="position-fixed bottom-0 end-0 mb-3 me-3 z-3">
            <Box sx={{ position: 'fixed', bottom: 16, right: 16 }}>
                {/* Botón flotante */}
                <SpeedDial
                    ariaLabel="Botón flotante de descarga"
                    icon={
                        <SpeedDialIcon
                            icon={<Download style={{ fontSize: '1.5rem' }} />}
                        />
                    }
                    FabProps={{
                        sx: {
                            bgcolor: '#da292e',
                            color: '#ffffff',
                            '&:hover': {
                                bgcolor: '#bb2d3b',
                            },
                        },
                    }}
                    onClick={() => {
                        const imageUrls = obtenerImagenesVisibles();
                        descargarImagenes(imageUrls);
                    }}
                />
            </Box>
            {/* Alerta que aparece automáticamente al renderizar */}
            <Snackbar
                open={showSnackbar}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} // Ubicación base
                onClose={() => setShowSnackbar(false)}
                sx={{
                    transform: 'translateX(-60px)', // Mueve la alerta ligeramente hacia la izquierda
                }}
            >
                <Alert
                    icon={<Download style={{ color: '#ffffff' }} />} // Cambia el color del icono a blanco
                    sx={{
                        bgcolor: '#da292e',
                        color: '#ffffff',
                        fontWeight: 'bold',
                        boxShadow: 3,
                    }}
                >
                    Descarga las imagenes aqui.
                </Alert>
            </Snackbar>
        </div>
    );
}